import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import { Toast } from 'antd-mobile';
import { validateIdcard, replaceName } from '../../utils/validate';
import ChangePayPwd from '../../components/personal/ChangePayPwd';

class VerifyCardId extends Component {
  constructor() {
    super();
    this.state = {
      cardId: '',
      name: ''
    }
  }

  componentDidMount() {
    this.setState({
      name: this.props.userInfo.name
    })
  }
 
  cardIdSureBack = (value) => {
    this.setState({
      cardId: value
    })
  }

  nextStep = () => {
    if (!validateIdcard(this.state.cardId)) {
      Toast.info('请输入正确的身份证号！', 2);
      return;
    }
    this.props.cardIdSuccess(this.state.cardId);
  }

  render () {
    return (
      <div>
        <ChangePayPwd
          title='验证身份证号'
          subTitle={`输入${replaceName(this.state.name)}的身份证号，以验证身份`}
          btnTitle='下一步'
          isCardId
          cardIdSureBack={this.cardIdSureBack}
          nextStep={this.nextStep}
          >
        </ChangePayPwd>
      </div>
    )
  }
}

VerifyCardId.propTypes = {
  cardIdSuccess: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo
  }
}

export default connect(mapStateToProps)(VerifyCardId);